import React, { useRef, useState } from 'react';
import { useEffect } from 'react';
import { FaBackward, FaForward } from 'react-icons/fa';
import { MdPauseCircleFilled, MdPlayCircleFilled, MdVolumeOff, MdVolumeUp } from 'react-icons/md';

export default function VideoPlayer({ src, controls }) {
    
    const [playing, setPlaying] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);
    // const [videoTime, setVideoTime] = useState(0);
    // const [progress, setProgress] = useState(0);
    const [mute, setMute] = useState(false);
    // const [playingOnMouseDown, setPlayingOnMouseDown] = useState(false);
    // const [onChangeUsed, setOnChangeUsed] = useState(false);
    const [ duration, setDuration ] = useState();


    const videoRef = useRef();

    useEffect(() => {
        const videoEl = videoRef.current;
        if (videoEl){
            if (videoEl?.currentTime) setCurrentTime(videoEl?.currentTime)
            setDuration(videoRef.current.duration.toFixed(4));
        }
        return () => {}
    }, []);

    const fastForward = () => {
        videoRef.current.currentTime += 5;
    };

    const revert = () => {
        videoRef.current.currentTime -= 5;
    };

    const videoHandler = (control) => {
        if (control === "play") {
            videoRef.current.play();
            setPlaying(true);
        } else if (control === "pause") {
            videoRef.current.pause();
            setPlaying(false);
        }
    };



    // const _handleMouseDown = () => {
    //     setPlayingOnMouseDown(videoRef.current.isPlaying);
    //     videoRef.current.pause();
    // }

    // const _handleMouseUp = ({ target: { value } }) => {
    //     if (!onChangeUsed) {
    //         videoRef.current.seekTo(+value)
    //     }

    //     if(playingOnMouseDown){
    //         videoRef.current.play();
    //     }
    // }

    // const _handleChange = ({ target: { value } }) => {
    //     videoRef.current.seekTo(+value)
    //     setOnChangeUsed(true);
    // }

    // window.setInterval(function () {
    //     setCurrentTime(videoRef.current?.currentTime);
    //     setProgress((videoRef.current?.currentTime / videoTime) * 100);
    // }, 1000);

  return (
    <div className='relative'>
        <video
            id="videoPlayer"
            ref={videoRef}
            muted={mute}
            className="h-full w-full rounded-xl"
            src={src}
        ></video>

        <div className="absolute opacity-0 hover:opacity-100 rounded-xl h-full w-full left-0 top-0" style={{
            backgroundColor: 'rgba(0,0,0, .4)',
        }} >
            <div className='flex justify-end flex-col h-full w-full'>
                <div className={`flex ${controls ? 'h-[84%]' : 'h-full'} w-full items-center justify-center flex-col`}>
                      <button onClick={(e) => videoHandler(playing ? 'pause' : 'play')} className='text-white text-6xl'>
                        { !playing  ? <MdPlayCircleFilled /> : <MdPauseCircleFilled /> }
                    </button>
                </div>
                {controls && <div className="flex h-[16%] justify-between gap-3 items-center px-4">
                    <span className='text-white font-semibold text-sm'>
                        {Math.floor(currentTime / 60) +
                            ":" +
                            ("0" + Math.floor(currentTime % 60)).slice(-2)}
                    </span>
                    <button onClick={revert} className='text-xl  text-white relative'>
                        <FaBackward />
                    </button>
                    <div className='w-full mt-2'>
                        <input
                            type="range"
                            max={duration}
                            defaultValue={currentTime}
                            className="w-full h-6 border-none p-0 cursor-pointer"
                        />
                    </div>
                      <button onClick={fastForward} className='text-xl text-white flex relative'>
                        <FaForward />
                    </button>
                    <button onClick={() => setMute(!mute)} className='text-xl text-white'>
                        {mute ? <MdVolumeOff />  : <MdVolumeUp />}
                    </button>
                </div>}
            </div>
        </div>
    </div>
  )
}
